import React from "react";
import Introducao from "./lessons/JoaoEAsEtapasDaHemostasia";

export default [
  {
    slugifiedLessonTitle: "joao-e-as-etapas-da-hemostasia",
    element: <Introducao />,
  },
];
